var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.756 4.424a.6.6 0 0 0-.848-.848L7.332 4zM3.332 8l-.424-.424a.6.6 0 0 0 0 .848zm3.576 4.424a.6.6 0 0 0 .848-.848L7.332 12zM12.665 8.6a.6.6 0 0 0 0-1.2v1.2M7.332 4l-.424-.424-4 4L3.332 8l.424.424 4-4zm-4 4-.424.424 4 4L7.332 12l.424-.424-4-4zm0 0v.6h9.333V7.4H3.332z"
  })));
};
export default SvgArrowLeft;